import React from "react";
import {
  StyleSheet,
  Text,
  View,
  useWindowDimensions,
  ImageBackground,
} from "react-native";
import { useComponent } from "../providers/ConfigProvider";
import { TextCards } from "../components/TextCards";
import { BlurView } from "expo-blur";
import { PaginatedEvents } from "../components/PaginatedEvents";
import { useTranslation } from "react-i18next";
import { TemplateProps } from "../../types";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";
import { TopBar } from "../components/TopBar";

const makeLayoutStyles = (theme: ThemeOptions) => {
  return StyleSheet.create({
    page: {
      flex: 1,
      flexGrow: 1,
      backgroundColor: theme.background,
    },
    mainContent: {
      flex: 1,
      flexDirection: "row",
    },
    leftColumn: {
      alignItems: "center",
      paddingBottom: theme.spacing.medium,
      flexGrow: 1,
      backgroundColor: theme.toRgba(theme.background, 0.4),
    },
    rightColumn: {
      backgroundColor: theme.toRgba(theme.background, 0.5),
      flexGrow: 1,
      position: "relative",
    },
    rightColumnBlur: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    todayText: {
      color: theme.backgroundText,
      padding: theme.spacing.medium,
      fontSize: theme.fontSize.h4,
      borderLeftWidth: theme.borderWidth.large,
      borderColor: "transparent",
      opacity: 0.6,
    },
  });
};

export const Basic = ({ onLoopComplete }: TemplateProps) => {
  const theme = useTheme();
  const { t } = useTranslation("TemplateScreen");
  const styles = makeLayoutStyles(theme);
  const schedule = useComponent("schedule", "right_schedule");
  const cards = useComponent("cards", "bottom_content_cards");
  const { width, height } = useWindowDimensions();

  return (
    <ImageBackground
      resizeMode="cover"
      imageStyle={{ width, height }}
      style={styles.page}
      source={{ uri: theme.backgroundImageUrl }}
    >
      <TopBar />
      <View style={styles.mainContent}>
        <View style={styles.leftColumn}>
          <View style={{ flexGrow: 2 }}></View>
          <TextCards
            data={cards}
            style={{
              width: "70%",
              flexGrow: 2,
              backgroundColor: theme.background,
            }}
          />
          <View style={{ flexGrow: 2 }}></View>
        </View>
        <View style={styles.rightColumn}>
          <BlurView tint="dark" intensity={30} style={styles.rightColumnBlur}>
            <Text style={styles.todayText}>{t("Today")}</Text>
            <PaginatedEvents
              style={{ flexGrow: 5 }}
              events={schedule?.events ?? []}
              timeZone={schedule?.timeZone}
              onLoopComplete={onLoopComplete}
              disableLoop={schedule?.disableLoop}
              nextDayEvents={schedule?.nextDayEvents}
            />
          </BlurView>
        </View>
      </View>
    </ImageBackground>
  );
};
